var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{ref:"btn",staticClass:"ion-button",class:[_vm.clickStatus ? 'not-allowed' : '', _vm.btnIcon && 'icon-btn'],style:({ padding: _vm.padding }),attrs:{"type":_vm.type,"icon":_vm.btnIcon,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v("按钮")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }